import { DColorBoxLabel, DKVColorBoxLabel } from "../../../components/ColorBox";
import { Cube } from "../../../state/types";
import { Info, KV } from "../util";
import { BearingCapacity } from "./BearingCapacity";

const SoilEx = ({ data }) => {
  if (!data) return null;
  // "source", "year", "internal"
  return <KV k="Ontgraven">{data?.[0].name}</KV>;
};

export const Soil = ({ field }: { field: Cube }) => {
  const { soil, soil2, landCover, excavated } = field?.data || {};
  if (!soil) return null;
  return (
    <Info as="dl">
      <KV k="Grondsoort">
        <DColorBoxLabel elem={soil} />
        <DColorBoxLabel elem={soil2} />
      </KV>
      <DKVColorBoxLabel k="Grondgebruik" elem={landCover} />
      <BearingCapacity field={field} />
      <SoilEx data={excavated} />
    </Info>
  );
};
